import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import axios from 'axios'


// axios.defaults.baseURL = 'http://localhost:8000';
axios.defaults.baseURL = 'https://it-work.wanorn.com/backend';
axios.defaults.headers.common['Authorization'] = `Bearer ${localStorage.getItem('token')}`;
axios.defaults.withCredentials = true;

import './assets/main.css';
// import 'bootstrap/dist/css/bootstrap.min.css';
// import 'bootstrap/dist/js/bootstrap.bundle';

import 'bootstrap-icons/font/bootstrap-icons.css';

import SmartTable from 'vuejs-smart-table'

import VueDatePicker from '@vuepic/vue-datepicker';
import '@vuepic/vue-datepicker/dist/main.css'

import vSelect from 'vue-select'
import 'vue-select/dist/vue-select.css';

const app = createApp(App);
app.component('v-select', vSelect)
app.component('VueDatePicker', VueDatePicker)
app.use(SmartTable)

app.use(store); // Register Vuex store
app.use(router); // Register router
app.mount('#app');

document.body.classList.add('app', 'sidebar');